import React, { useCallback, useEffect, useRef, useState } from "react";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Divider, Form, Input, Select, Space } from "antd";

import { Option } from "antd/es/mentions";
import { ModalPortal } from "./components/ModalPortal";


// const initialState = [  
// {
//   icono:"auto",
//   titulo: "Automovil",
//   url: "https://agnnissan.com.ar/vehiculos/autos/sentra-2/",
//   imagen: "https://agnnissan.com.ar/wp-content/uploads/2024/03/nissan-nuevo-nissan-versa-bl.jpg",
// },
// {
//   icono:"camioneta",
//   titulo: "Nissan Kicks",
//   url: "https://agnnissan.com.ar/vehiculos/autos/x-trail-e-power/",
//   imagen: "https://agnnissan.com.ar/wp-content/uploads/2024/03/nissan-kicks.png",
// },];

export const FormEnlances = ({ enlaces = [], setEnlaces, handleSubmitEnlaces }) => {

  const firstRender = useRef(true)
  const [showPortalModal, setShowPortalModal] = useState(false);
  const [confirmAction, setConfirmAction] = useState(false)
  const [listaLocal, setListaLocal] = useState(enlaces || [])
  const [isDataModified, setIsDataModified] = useState(false)

  // const getModalConfirmation = new Promise((resolve, reject) => {
  //   setConfirmAction(false)
  //   resolve(true)
  // })

  const iconsList = [
    "auto",
    "camioneta",
    "habitacion",
    "casa",
    "demo"
  ]
  

  const onFinish = (values) => {    
    // setShowPortalModal(true);    
    setListaLocal([...values.listadoEnlaces]);            
    
    //  console.log("Estado de Lista Local en FormEnlances: ", listaLocal);
    
    handleSubmitEnlaces(values.listadoEnlaces);
    
    
    if(confirmAction) {      
      
    }
  };  

  const handleOnChangeData = () => {
    setIsDataModified(true)
  }


  return (
    <>
      {/* <Title level={5}>Formulario de Enlaces</Title> */}
      <Form        
        name="links-form"
        onFinish={onFinish}
        initialValues={{
          listadoEnlaces: enlaces,}}
        style={{          
          maxWidth: 600,          
        }}
        autoComplete="off"
        layout="vertical"
      >
        <Form.List name="listadoEnlaces">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <Space
                  key={key}
                  style={{
                    backgroundColor: "#071529",
                    display: "flex",
                    flexDirection: "column",
                    marginBottom: 8,
                    padding: 10,
                    color: "white",
                    alignItems: "center",
                  }}
                  align="baseline"
                >
                  <Divider style={{color:"white"}} orientation="left"  plain>
                    <b><u>Datos de Enlace:</u></b>
                  </Divider>
                  <Form.Item                                        
                    {...restField}
                    name={[name, "icono"]}
                    rules={[
                      {
                        required: true,
                        message: "el icono es obligatorio",
                      },
                    ]}
                    label={<span style={{color:"white"}}>Icono</span>}
                  >
                    <Select
                      placeholder="seleccione un icono"
                      onChange={handleOnChangeData}
                      allowClear
                    >
                      {iconsList.map((icon, index) => (
                        <Option key={index} value={icon}>
                          {icon}
                        </Option>
                      ))}                      
                    </Select>
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, "titulo"]}
                    rules={[
                      {
                        required: true,
                        message: "el titulo es obligatorio",
                      },
                    ]}
                    label={<span style={{color:"white"}}>Titulo</span>}
                  >
                    <Input onChange={handleOnChangeData} placeholder="titulo del enlace" />
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, "url"]}
                    rules={[
                      {
                        required: true,
                        message: "la url es obligatoria",
                      },
                    ]}
                    label={<span style={{color:"white"}}>Url</span>}
                  >
                    <Input onChange={handleOnChangeData} placeholder="url del enlace" />
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, "imagen"]}
                    rules={[
                      {
                        required: true,
                        message: "la imagen es obligatoria",
                      },
                    ]}
                    label={<span style={{color:"white"}}>Imagen</span>}
                  >
                    <Input onChange={handleOnChangeData} placeholder="imagen del enlace" />
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, "otraExperiencia"]}
                    rules={[
                      {
                        required: false,
                        message: "el enlace de experiencia externa no es obligatorio",
                      },
                    ]}
                    label={<span style={{color:"white"}}>Url Imagen 360</span>}
                  >
                    <Input onChange={handleOnChangeData} placeholder="url imagen de experiencia externa" />
                  </Form.Item>

                  <MinusCircleOutlined 
                    onClick={()=>remove(name)} 
                     //onClick={handleOnClick("remove", add, remove, name)} 
                  />
                </Space>
              ))}
              <Form.Item>
                <Button
                  type="dashed"
                  //onClick={handleOnClick("add", add, remove)}
                  onClick={()=>add()}
                  block
                  icon={<PlusOutlined />}
                >
                  Add field
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
        <Form.Item>          
          <Button 
            disabled={!isDataModified}
            type="primary" htmlType="submit">
            Guardar Cambios
          </Button>
        </Form.Item>
      </Form>
      <ModalPortal  showModal={showPortalModal} setShowModal={setShowPortalModal} setConfirmAction={setConfirmAction}  />
    </>
  );
};
